module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-SPORT-0-2.f75252ea.jpg";